__turbopack_context__.v({
  "breadcrumbs": "breadcrumbs-module-scss-module__H0OA5a__breadcrumbs",
  "centered": "breadcrumbs-module-scss-module__H0OA5a__centered",
});
